import { useState, useEffect } from "react";
import { degrees, PDFDocument, rgb, StandardFonts } from "pdf-lib";
import PDFTEMPLATE from "../assets/flyers/DPA.pdf";
import OTHLLogo from "../assets/images/OTHL-logo.png";
import fontkit from "@pdf-lib/fontkit";
import RobotoFontCondensed from "../assets/fonts/Roboto-BoldCondensed.ttf";
import MinionFont from "../assets/fonts/MinionPro-Regular.otf";
import ArlialnFont from "../assets/fonts/ARIALN.ttf";
import { trackDownload } from "./analytics";

async function makeFlyerTemplateOne(
  userData,
  previewOrDownload,
  setLoading,
  enableCobranding,
  cobrandHeadshot
) {
  let url = userData.flyerChoice.filePath;
  let brandColorObj = userData.brand.rgbHeader;
  let headerColor = rgb(brandColorObj[0], brandColorObj[1], brandColorObj[2]);
  // const licensingSplit = userData.brand.Licensing.slice(0, 30); // first line
  // const licensingSplit2 = userData.brand.Licensing.slice(30); // second line

  let brandCtaColorObj = userData.brand.rgbCta;
  let ctaColor = rgb(
    brandCtaColorObj[0],
    brandCtaColorObj[1],
    brandCtaColorObj[2]
  );



  if (window.location.hostname === "localhost") {
    url = PDFTEMPLATE;
  }

  let branchLicense = userData.branch.Licensing;

  let licensingLineOne = userData.brand.licensingLineOne;
  let licensingLineTwo = userData.brand.licensingLineTwo;
  let licensingLineThree = userData.brand.licensingLineThree;
  let licensingLineFour = userData.brand.licensingLineFour;

  if (userData.flyerChoice.Spanish == true) {
    branchLicense = userData.branch.SpanishLicensing;
    licensingLineOne = userData.brand.SpanishlicensingLineOne;
    licensingLineTwo = userData.brand.SpanishlicensingLineTwo;
    licensingLineThree = userData.brand.SpanishlicensingLineThree;
    licensingLineFour = userData.brand.SpanishlicensingLineFour;
  }

  let nmmlNumberHeight = 342;
  let officeNumber = 330;
  let mobileNumberHeight = 319;
  let faxNumberHeight = 306;
  let emailHeight = 294;
  let mloWebsiteHeight = 282;

  if (userData.settings.user.mobileNumber === false) {
    faxNumberHeight = faxNumberHeight + 12;
    emailHeight = emailHeight + 12;
    mloWebsiteHeight = mloWebsiteHeight + 12;
  }

  if (userData.settings.user.faxNumber === false) {
    emailHeight = emailHeight + 12;
    mloWebsiteHeight = mloWebsiteHeight + 12;
  }

  if (
    userData.settings.user.headshot === true &&
    (userData.settings.user.mobileNumber === false ||
      userData.settings.user.faxNumber === false)
  ) {
    emailHeight = emailHeight - 12;
    mloWebsiteHeight = mloWebsiteHeight - 12;
  }

  if (
    userData.settings.user.headshot === true &&
    userData.settings.user.mobileNumber === false &&
    userData.settings.user.faxNumber === false
  ) {
    emailHeight = emailHeight - 12;
    mloWebsiteHeight = mloWebsiteHeight - 12;
  }

  let person = userData.userData;
  const existingPdfBytes = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/pdf",
    },
  }).then((res) => res.arrayBuffer());

  const fontBytesforRoboto = await fetch(RobotoFontCondensed).then((res) =>
    res.arrayBuffer()
  );

  const fontBytesforMinion = await fetch(MinionFont).then((res) =>
    res.arrayBuffer()
  );
  const fontBytesforArlian = await fetch(ArlialnFont).then((res) =>
    res.arrayBuffer()
  );

  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  pdfDoc.registerFontkit(fontkit);
  const robotoFontCondensed = await pdfDoc.embedFont(fontBytesforRoboto);
  // const minionFont = await pdfDoc.embedFont(fontBytesforMinion);
  const arlianFont = await pdfDoc.embedFont(fontBytesforArlian);
  const minionFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);

  const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const helveticaBoldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  const pages = pdfDoc.getPages();
  const firstPage = pages[0];
  const { width, height } = firstPage.getSize();
  // console.log(width, height);
  // console.log(userData.brand.headerColor);

  if (userData.brand.hasHeader) {
    firstPage.drawRectangle({
      x: 0,
      y: 716,
      width: 612,
      height: 90,
      color: headerColor,
    });
  }

  firstPage.drawRectangle({
    x: 407,
    y: 365.48,
    width: 100,
    height: 0.3,
    color: rgb(0.5, 0.5, 0.5),
  });
  if (userData.flyerChoice.Spanish == true) {
    firstPage.drawRectangle({
      x: 403,
      y: 407,
      width: 203,
      height: 45,
      color: ctaColor,
    });
    firstPage.drawText("LLAME A SU EQUIPO DE", {
      x: 445,
      y: 432.7,
      font: robotoFontCondensed,
      size: 13,
      color: rgb(1, 1, 1),
    });
    firstPage.drawText("FINANCIAMENTO DE VIVIENDAS HOY!", {
      x: 407.5,
      y: 415.5,
      font: robotoFontCondensed,
      size: 13,
      color: rgb(1, 1, 1),
    });
  } else {
    firstPage.drawRectangle({
      x: 404,
      y: 407,
      width: 195,
      height: 45,
      color: ctaColor,
    });

    if (
      userData.flyerChoice.ctaLineOne !== "" &&
      userData.flyerChoice.ctaLineOne !== undefined &&
      userData.flyerChoice.ctaLineOne !== null
    ) {
      firstPage.drawText(`${userData.flyerChoice.ctaLineOne}`, {
        x: 415,
        y: 432.2,
        font: robotoFontCondensed,
        size: 15,
        color: rgb(1, 1, 1),
      });
    } else {
      firstPage.drawText("CALL YOUR HOME", {
        x: 449,
        y: 432.2,
        font: robotoFontCondensed,
        size: 15,
        color: rgb(1, 1, 1),
      });
    }

    if (
      userData.flyerChoice.ctaLineTwo !== "" &&
      userData.flyerChoice.ctaLineTwo !== undefined &&
      userData.flyerChoice.ctaLineTwo !== null
    ) {
      firstPage.drawText(`${userData.flyerChoice.ctaLineTwo}`, {
        x: 415,
        y: 415.5,
        font: robotoFontCondensed,
        size: 15,
        color: rgb(1, 1, 1),
      });
    } else {
      firstPage.drawText("FINANCING TEAM TODAY!", {
        x: 426.5,
        y: 415.5,
        font: robotoFontCondensed,
        size: 15,
        color: rgb(1, 1, 1),
      });
    }
  }

  firstPage.drawText(`${person.FirstName.toUpperCase()}`, {
    x: width - 203,
    y: 385,
    size: 14.5,
    font: robotoFontCondensed,
    color: rgb(0.196, 0.196, 0.196),
    weight: "bold",
  });

  firstPage.drawText(`${person.LastName.toUpperCase()}`, {
    x: width - 203,
    y: 370,
    size: 14.5,
    font: robotoFontCondensed,
    color: rgb(0.196, 0.196, 0.196),
  });
  const textWidth = minionFont.widthOfTextAtSize(`${person.Title}`, 10);

  // split on spaces and /
  const trimmedTitle = person.Title.split(" ");

  // Initialize an array to store title lines
  const titleLines = [];
  let titleLine = "";

  // Split title into multiple lines based on width constraint
  for (let word of trimmedTitle) {
    let testLine = titleLine + word + " ";
    let testWidth = minionFont.widthOfTextAtSize(testLine, 10);
    if (testWidth > 100) {
      titleLines.push(titleLine.trim());
      titleLine = word + " ";
    } else {
      titleLine = testLine;
    }
  }
  titleLines.push(titleLine.trim());

  // Set initial height for the title and dynamically adjust `textHeight` based on title lines
  let titleHeight = 355;
  let textHeight = titleHeight - titleLines.length * 11; // Calculate textHeight based on title lines

  // Draw each line of the title
  for (let line of titleLines) {
    firstPage.drawText(line, {
      x: width - 203,
      y: titleHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    titleHeight -= 11;
  }

  // Check which contact information is available
  const hasPhone = person.Phone !== "";
  const hasMobile =
    userData.settings.user.mobileNumber &&
    person.Mobile_Phone_Formatted__c !== "";
  const hasFax = userData.settings.user.faxNumber && person.Fax !== "";
  const minimalContactInfo = !hasPhone && !hasMobile && !hasFax;

  // Determine the offset based on available contact information
  const shouldOffsetEmailAndWebsite =
    titleLines.length === 1 &&
    userData.settings.user.headshot &&
    (!hasMobile || !hasFax);

  // Set email and website positions based on conditions
  let emailYOffset = minimalContactInfo
    ? -40
    : shouldOffsetEmailAndWebsite
    ? -12
    : 0;

  // Draw other text fields (NMLS, phone, etc.) based on adjusted textHeight
  if (person.LoanForce__NMLS_Number__c !== "") {
    firstPage.drawText(`NMLS #${person.LoanForce__NMLS_Number__c}`, {
      x: width - 203,
      y: textHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    textHeight -= 12;
  }

  if (hasPhone) {
    firstPage.drawText(`O: ${person.Phone}`, {
      x: width - 203,
      y: textHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    textHeight -= 12;
  }

  if (hasMobile) {
    firstPage.drawText(`M: ${person.Mobile_Phone_Formatted__c}`, {
      x: width - 203,
      y: textHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    textHeight -= 12;
  }

  if (hasFax) {
    firstPage.drawText(`F:  ${person.Fax}`, {
      x: width - 203,
      y: textHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    textHeight -= 12;
  }

  if (!hasFax && !hasMobile) emailYOffset = emailYOffset - 12;

  // measure the width of the `E: ${person.Email}`
  const emailWidth = minionFont.widthOfTextAtSize(`E: ${person.Email}`, 10);

  if (!userData.settings.user.headshot) emailYOffset = 0;
  // Draw the email line with `emailYOffset` applied based on conditions
  firstPage.drawText(`E: ${person.Email}`, {
    x: width - 203,
    y: textHeight + emailYOffset,
    size: 10,
    font: minionFont,
    color: rgb(0, 0, 0),
  });
  textHeight -= 12 - emailYOffset; // Adjust textHeight after drawing the email

  // Draw the website directly below the email, using the updated textHeight without additional offset
  if (userData.settings.user.customMloWebsite === true) {
    firstPage.drawText(`${userData.settings.user.customMloWebsiteUrl}`, {
      x: width - 203,
      y: textHeight, // Use the updated textHeight for the website, ensuring it appears below the email
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    textHeight -= 12;
  }

  let subDomainUrl = "contact/";

  if (
    userData.settings.user.mloWebsite &&
    !userData.settings.user.customMloWebsite
  ) {
    firstPage.drawText(
      `${userData.brand.WebsiteUrl}${subDomainUrl}${person.Account}`,
      {
        x: width - 203,
        y: textHeight,
        size: 10,
        font: minionFont,
        color: rgb(0, 0, 0),
      }
    );
    textHeight -= 12;
  }
  // console.log(userData.userData.mloHeadshotFinal);
  if (userData.userData.mloHeadshotFinal === "") {
    // console.log("no headshot");
  } else {
    const headshotImage = await fetch(person.mloHeadshotFinal).then((res) =>
      res.arrayBuffer()
    );
    const headshot = await pdfDoc.embedPng(headshotImage);
    if (userData.settings.user.headshot) {
      firstPage.drawImage(headshot, {
        x: width - 94,
        y: 315,
        width: 80,
        height: 80,
      });
    }
  }
  // download the headshotImage

  // const pngUrl = userData.brand.whiteLogoUrl;
  const pngUrl = userData.brand.whiteLogoUrl;
  const pngImageBytes = await fetch(pngUrl).then((res) => res.arrayBuffer());
  const pngImage = await pdfDoc.embedPng(pngImageBytes);

  let pngDims = pngImage.scale(0.6);

  if (userData.brand.BrandName === "Tabor Mortgage") {
    pngDims = pngImage.scale(0.7);
  }

  firstPage.drawImage(pngImage, {
    x: firstPage.getWidth() / 2 - pngDims.width / 2,
    y: firstPage.getHeight() - pngDims.height / 2 - 35,
    height: pngDims.height,
    width: pngDims.width,
  });

  // LICENSING INFORMATION
  //
  //
  //
  //
  //
  //
  //
  //
  // LICENSING INFORMATION

  let textFontSize = 8;

  if (userData.flyerChoice.Spanish == true) {
    textFontSize = 7;
  }

  firstPage.drawText(`NMLS #${userData.branch.NMLS}`, {
    x: width - 535,
    y: 60,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });
  firstPage.drawText(`${userData.branch.Address}`, {
    x: width - 420,
    y: 60,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });

  firstPage.drawText(`${branchLicense}`, {
    x: width - 535,
    y: 50,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });

  // userData.brand.licensing break up into an array of words

  firstPage.drawText(`${licensingLineOne}`, {
    x: width - 535,
    y: 40,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });
  firstPage.drawText(`${licensingLineTwo}`, {
    x: width - 535,
    y: 30,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });
  firstPage.drawText(`${licensingLineThree}`, {
    x: width - 535,
    y: 20,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });

  let reverseFLyer = userData.flyerChoice.name.includes("Reverse Mortgage");

  if (
    userData.brand.reverseLicensing !== "" &&
    userData.brand.reverseLicensing !== null &&
    userData.brand.reverseLicensing !== undefined &&
    reverseFLyer &&
    userData.flyerChoice.b2b
  ) {
    // replace "BRAND_URL" in userData.brand.reverseLicensing with userData.brand.WebsiteUrl
    userData.brand.reverseLicensing = userData.brand.reverseLicensing.replace(
      /BRAND_URL/g,
      userData.brand.WebsiteUrl
    );

    firstPage.drawText(
      `${licensingLineFour} ${userData.brand.reverseLicensing} ${userData.flyerChoice.b2bLanguage}`,
      {
        x: width - 535,
        y: 10,
        size: textFontSize,
        font: arlianFont,
        color: rgb(0.196, 0.196, 0.196),
      }
    );
  } else if (
    userData.brand.reverseLicensing !== "" &&
    userData.brand.reverseLicensing !== null &&
    userData.brand.reverseLicensing !== undefined &&
    reverseFLyer
  ) {
    userData.brand.reverseLicensing = userData.brand.reverseLicensing.replace(
      /BRAND_URL/g,
      userData.brand.WebsiteUrl
    );
    firstPage.drawText(
      `${licensingLineFour} ${userData.brand.reverseLicensing}  `,
      {
        x: width - 535,
        y: 10,
        size: textFontSize,
        font: arlianFont,
        color: rgb(0.196, 0.196, 0.196),
      }
    );
  } else if (userData.flyerChoice.b2b) {
    firstPage.drawText(
      `${licensingLineFour} ${userData.flyerChoice.b2bLanguage} `,
      {
        x: width - 535,
        y: 10,
        size: textFontSize,
        font: arlianFont,
        color: rgb(0.196, 0.196, 0.196),
      }
    );
  } else {
    firstPage.drawText(`${licensingLineFour}`, {
      x: width - 535,
      y: 10,
      size: textFontSize,
      font: arlianFont,
      color: rgb(0.196, 0.196, 0.196),
    });
  }

  /// CO BRANDING SECTION
  //
  //
  //
  //
  /// CO BRANDING SECTION

  let cobrandCompanyNameHeight = 188;
  let cobrandPhoneNumberHeight;
  let cobrandFaxNumberHeight = 164;
  let cobrandEmailHeight = 152;
  let cobrandWebsite = 140;

  if (enableCobranding && userData.settings.coBrand.firstName !== "") {
    firstPage.drawText(`${userData.settings.coBrand.firstName.toUpperCase()}`, {
      x: width - 203,
      y: 230,
      size: 14.5,
      font: robotoFontCondensed,
      color: rgb(0.196, 0.196, 0.196),
      weight: "bold",
    });
  }

  if (enableCobranding && userData.settings.coBrand.lastName !== "") {
    firstPage.drawText(`${userData.settings.coBrand.lastName.toUpperCase()}`, {
      x: width - 203,
      y: 215,
      size: 14.5,
      font: robotoFontCondensed,
      color: rgb(0.196, 0.196, 0.196),
      weight: "bold",
    });
  }

  // TODO add split for company name
  const textWidthCompany = minionFont.widthOfTextAtSize(
    `${userData.settings.coBrand.companyName}`,
    10
  );
  const trimmedCompany = userData.settings.coBrand.companyName.split(" ");
  console.log(trimmedCompany);

  if (enableCobranding && userData.settings.coBrand.companyName !== "") {
    let length = 0;
    let line = "";
    let lines = [];
    for (let i = 0; i < trimmedCompany.length; i++) {
      let testLine = line + trimmedCompany[i] + " ";
      let testWidth = minionFont.widthOfTextAtSize(testLine, 10);
      if (testWidth > 100) {
        lines.push(line);
        line = trimmedCompany[i] + " ";
      } else {
        line = testLine;
      }
    }
    lines.push(line);

    for (let i = 0; i < lines.length; i++) {
      firstPage.drawText(`${lines[i]}`, {
        x: width - 203,
        y: cobrandCompanyNameHeight,
        size: 10,
        font: minionFont,
        color: rgb(0.196, 0.196, 0.196),
      });
      cobrandCompanyNameHeight -= 11;
    }
  }

  if (
    (enableCobranding && userData.settings.coBrand.companyName !== "") ||
    userData.settings.coBrand.companyName !== null
  ) {
    cobrandPhoneNumberHeight = cobrandCompanyNameHeight - 1;
    cobrandFaxNumberHeight = cobrandCompanyNameHeight - 12;
    cobrandEmailHeight = cobrandCompanyNameHeight - 24;
    cobrandWebsite = cobrandCompanyNameHeight - 36;
  }

  if (enableCobranding && userData.settings.coBrand.phoneNumber === "") {
    cobrandEmailHeight = cobrandEmailHeight + 12;
    cobrandFaxNumberHeight = cobrandFaxNumberHeight + 12;
    cobrandWebsite = cobrandWebsite + 12;
  }

  if (enableCobranding && userData.settings.coBrand.faxNumber === "") {
    cobrandWebsite = cobrandWebsite + 12;
    cobrandEmailHeight = cobrandEmailHeight + 12;
  }
  if (enableCobranding && userData.settings.coBrand.email === "") {
    cobrandFaxNumberHeight = cobrandFaxNumberHeight + 12;
    cobrandWebsite = cobrandWebsite + 12;
  }

  if (enableCobranding && cobrandHeadshot) {
    cobrandEmailHeight = 140;
    cobrandWebsite = 128;
  }
  if (enableCobranding) {
    firstPage.drawRectangle({
      x: 407,
      y: 209,
      width: 100,
      height: 0.3,
      color: rgb(0.5, 0.5, 0.5),
    });
  }
  if (enableCobranding && userData.settings.coBrand.title !== "") {
    firstPage.drawText(`${userData.settings.coBrand.title}`, {
      x: width - 203,
      y: 199,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }

  if (enableCobranding && userData.settings.coBrand.phoneNumber !== "") {
    firstPage.drawText(`O: ${userData.settings.coBrand.phoneNumber}`, {
      x: width - 203,
      y: cobrandPhoneNumberHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }
  if (enableCobranding && userData.settings.coBrand.faxNumber !== "") {
    firstPage.drawText(`M: ${userData.settings.coBrand.faxNumber}`, {
      x: width - 203,
      y: cobrandFaxNumberHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }

  if (enableCobranding && userData.settings.coBrand.email !== "") {
    firstPage.drawText(`E: ${userData.settings.coBrand.email}`, {
      x: width - 203,
      y: cobrandEmailHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }

  if (enableCobranding && userData.settings.coBrand.website !== "") {
    firstPage.drawText(`${userData.settings.coBrand.website}`, {
      x: width - 203,
      y: cobrandWebsite,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }

  if (enableCobranding && cobrandHeadshot) {
    const cobrandHeadshotUrl = cobrandHeadshot;
    // remove jpg from cobrandHeadshotUrl
    const cobrandHeadshotUrlNoJpg = cobrandHeadshotUrl.slice(0, -4);

    // console.log(cobrandHeadshotUrlNoJpg);
    const cobrandedFinal = cobrandHeadshotUrlNoJpg + ".png";
    // console.log(cobrandedFinal);
    const pngImageBytes3 = await fetch(cobrandedFinal).then((res) =>
      res.arrayBuffer()
    );
    const cobrandHeadshotimage = await pdfDoc.embedPng(pngImageBytes3);

    firstPage.drawImage(cobrandHeadshotimage, {
      x: width - 94,
      y: 150,
      width: 80,
      height: 80,
    });
  }

  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  const url2 = URL.createObjectURL(blob);
  console.log(blob, "here");

  if (previewOrDownload === "preview") {
    window.open(url2, "_blank");
  }
  if (previewOrDownload === "download") {
    const link = document.createElement("a");
    link.href = url2;
    link.download = `${userData.flyerChoice.name}`;
    link.click();
  }
  setLoading(false);
  await trackDownload(userData, userData.flyerChoice, enableCobranding);
  return pdfBytes;
}

export default makeFlyerTemplateOne;
